import { computed, type Ref, watch } from "vue";

import { useAppStore } from "~/stores";
import { when } from "~/utils/wait";

const updateModalOpenOnClose = async (modalWrapperRef: Ref<HTMLElement | null>) => {
  const appStore = useAppStore();
  await when(computed(() => !modalWrapperRef.value));
  appStore.isModalOpen = !!document.querySelector(".dart-modal-wrapper") && !document.querySelector("#mobile-leftbar");
};

export default function useModalOpenTracking(
  isOpen: () => boolean,
  modalWrapperRef: Ref<HTMLElement | null>,
  onOpen?: () => void
) {
  const appStore = useAppStore();

  watch(isOpen, async (newValue) => {
    if (!newValue) {
      await updateModalOpenOnClose(modalWrapperRef);
      return;
    }
    if (onOpen) {
      onOpen();
    } else {
      appStore.isModalOpen = true;
    }
  });
}
